"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.circle = exports.loadWrap = exports.dangerButton = exports.text = void 0;

var _react = require("@emotion/react");

var _core = require("@material-ui/core");

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  background-color: #fff;\n  border-radius: 50%;\n  display: inline-block;\n  height: 10px;\n  margin-right: 6px;\n  width: 10px;\n  animation: ", ";\n  animation-timing-function: cubic-bezier(0, 1, 1, 0);\n  margin-left: 10px;\n\n  &:nth-of-type(1) {\n    animation: ", " 0.8s infinite;\n  }\n\n  &:nth-of-type(2) {\n    animation: ", " 0.8s infinite;\n    margin-left: -10px;\n  }\n\n  &:nth-of-type(3) {\n    animation: ", " 0.8s infinite;\n  }\n\n  &:nth-of-type(4) {\n    animation: ", " 0.8s infinite;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    from {\n        transform: translate(0, 0);\n    }\n\n    to {\n        transform: translate(20px, 0);\n    }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    from {\n        transform: scale(1);\n    }\n\n    to {\n        transform: scale(0);\n    }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    from {\n        transform: scale(0);\n    }\n\n    to {\n        transform: scale(1);\n    }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var text = function text(theme) {
  return (0, _react.css)(_templateObject(), theme.colors.accent);
};

exports.text = text;

var dangerButton = function dangerButton(theme) {
  return (0, _react.css)(_templateObject2(), theme.colors.danger, theme.colors.white, (0, _core.lighten)(theme.colors.danger, 0.5));
};

exports.dangerButton = dangerButton;
var loadWrap = (0, _react.css)(_templateObject3());
exports.loadWrap = loadWrap;
var fadeIn = (0, _react.keyframes)(_templateObject4());
var loaderEllipsisFadeIn = (0, _react.keyframes)(_templateObject5());
var loaderEllipsisFadeOut = (0, _react.keyframes)(_templateObject6());
var loaderellipsismoveright = (0, _react.keyframes)(_templateObject7());
var circle = (0, _react.css)(_templateObject8(), fadeIn, loaderEllipsisFadeIn, loaderellipsismoveright, loaderellipsismoveright, loaderEllipsisFadeOut);
exports.circle = circle;